import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import LinkMapBody from './LinkMapBody';
import LinkMapData from './LinkMapData';
import { STATE_PROP_TYPES } from './states';

const messages = defineMessages({
  placeholder: {
    id: 'linkMapPlaceholder',
    defaultMessage: 'Add a title for the map',
  },
});

const LinkMapEdit = (props) => {
  const { selected, block } = props;
  const intl = useIntl();
  const placeholder = intl.formatMessage(messages.placeholder);

  return (
    <>
      <div className="link-map-block">
        <LinkMapBody {...props} isEditMode placeholder={placeholder} />
      </div>
      <SidebarPortal selected={selected}>
        <LinkMapData key={block} {...props} />
      </SidebarPortal>
    </>
  );
};

LinkMapEdit.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    linkTemplate: PropTypes.string,
    linkFormat: PropTypes.string,
    searchAcrossPortal: PropTypes.bool,
    useDarkTheme: PropTypes.bool,
    ...STATE_PROP_TYPES,
  }),
  selected: PropTypes.bool,
  block: PropTypes.string,
};

export default LinkMapEdit;
